import "./namespace.js";
import "#legacy/utilities/regexp.js";

// NOTE: For hierarchical options to work, parent options must have `children == true`
//       and all children must be organized consecutively following their parent.
window.UberSelectExtensions.nestedOptions = {
  selectCaret: false, // Using CSS to create a caret
  prepopulateSearchOnOpen: false,
  clearSearchClearsSelect: true,
  treatBlankOptionAsPlaceholder: false,
  patternForMatching: function (processedQuery) {
    return new RegExp("\\b" + Sparkle.Utilities.escapeForRegExp(processedQuery), "i"); // Match only the beginnings of words
  },

  resultPostprocessor: function (result, datum) {
    var optionData = jQuery(datum.element).data();
    var isParent = !!optionData.children;
    var isChild = !!optionData.parent;
    var input = jQuery(datum.element).closest("select").parent().siblings().find(".search_input");

    if (input.val()) {
      return;
    }

    if (isParent) {
      var toggle = jQuery('<i class="child_toggle" data-behaviour="child-toggle"></i>');
      result
        .addClass("parent")
        .append(toggle)
        .on("keydown", function (event) {
          if (event.which === 39) {
            // Expand the children if the right arrow is clicked
            if (!toggle.hasClass("open")) {
              toggle.trigger("click");
            }
            return false;
          } else if (event.which === 37) {
            // Collapse the children if the left arrow is clicked
            if (toggle.hasClass("open")) {
              toggle.trigger("click");
            }
            return false;
          }
        });
    }

    if (isChild) {
      result
        .addClass("child hidden")
        .prepend("<span class='child_indicator'></span>")
        .attr({ "data-parent": optionData.parent, "data-depth": optionData.depth });

      var i = optionData.depth;
      while (--i) {
        result.prepend("<span class='child_indicator_spacing'></span>");
      }
    }

    if (optionData.parentName) {
      result.append(jQuery('<span class="parent_name"></span>').text(" (" + optionData.parentName + ")"));
    }

    if (optionData.subtext) {
      result.append(jQuery('<span class="result_subtext"></span>').text(optionData.subtext));
    }
  },

  onRender: function (_, selectedResult) {
    selectedResult = jQuery(selectedResult);
    if (selectedResult.hasClass("child")) {
      var toggle = selectedResult.prevAll(".parent").first().find('[data-behaviour~="child-toggle"]');
      if (!toggle.hasClass("open")) {
        toggle.trigger("click");
      }
    }
    if (selectedResult.hasClass("parent")) {
      var toggle = selectedResult.find('[data-behaviour~="child-toggle"]');
      if (!toggle.hasClass("open")) {
        toggle.trigger("click");
      }
    }
  },

  onSelect: function (datum, result, originalEvent) {
    var childDropdown = jQuery(originalEvent.target).closest("[data-behaviour~=child-toggle]");
    if (childDropdown.length) {
      childDropdown.toggleClass("open");
      result = jQuery(result);
      var list = result.closest("ul");
      list
        .find('.result.child[data-parent="' + datum.value + '"]')
        .toggleClass("hidden", !childDropdown.hasClass("open"));
      return false;
    }
  },
};
